import React, { useState } from 'react';
import './Searchwidget.scss';

import { Modal, Button, } from 'react-bootstrap';

function SearchWidget() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [search,setSearch] = useState("");

    const handleSearch = () => { 
        window.location ="/tags/"+ search +"/article";  
    }
    return (
        <>
            <a aria-label="Search" width="40" height="40" className="h_searchlink" onClick={handleShow}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="#A50404">
                    <path id="search" d="M50.51,48.159l-9.616-9.616A16.843,16.843,0,1,0,38.535,40.9l9.616,9.608a1.665,1.665,0,0,0,2.359-2.351Zm-22.653-6.8a13.506,13.506,0,1,1,13.51-13.5A13.519,13.519,0,0,1,27.857,41.359Z" transform="translate(-11 -11)" />
                </svg>
            </a>

            <Modal show={show} onHide={handleClose} className="search_model">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="search_wrap">
                        <div className="search_form"><input type="text" placeholder="Search on Webdunia" value={search} onChange= {(e) => setSearch(e.target.value)} className="Search_Field"/></div>
                        <div className="search_btn"><a onClick = {handleSearch}><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="#A50404">
                            <path id="search" d="M50.51,48.159l-9.616-9.616A16.843,16.843,0,1,0,38.535,40.9l9.616,9.608a1.665,1.665,0,0,0,2.359-2.351Zm-22.653-6.8a13.506,13.506,0,1,1,13.51-13.5A13.519,13.519,0,0,1,27.857,41.359Z" transform="translate(-11 -11)" />
                        </svg></a></div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default SearchWidget;